export default __webpack_public_path__ + "static/media/settings-icon.b1d779b9.svg";